export default {
	props:{
		formTitle:{type:String, default(){ return this.$t('bookingItemCancelForm.formTitle');} },
		bookingId: {type:[String, Number]},
		bookingItemId: {type:[String, Number]},
	},
	data(){
		return {
			formData: {},
			formErrors: {},
			successMsg: '',
		}
	},
	computed:{
		actionName(){
			return 'doCancelRoom';
		},
		actionUrl(){
			const url = new URL(window.location.href);
			url.searchParams.set('action', this.actionName);
			return url.href;
		},
		hasErrors(){
			return this.formErrors && Object.values(this.formErrors).length;
		},
	},
	methods: {
		onHideModalDialog(event){
			if(this.successMsg){
				window.location.reload();
			}
		},
		onFormSubmit(event){
			this.$refs.qForm.classList.add('submitting');
			this.formErrors = {};
			this.successMsg = '';
			doFetch(this.actionUrl, {}, {'bookingId':this.bookingId, 'bookingItemId':this.bookingItemId, 'cancelDetails':this.formData})
				.then((res) => {
					if (!res || !res.success){
						this.formErrors = res.errors ? res.errors : {'main':'Unknown error!'};
						return;
					}
					this.formData = {};
					this.successMsg = res.success_msg;
					this.$emit('success', {success_msg:res.success_msg});
				})
				.catch((error)=>{
					//error
					alert('Unknown error!');
				})
				.finally(()=>{
					this.$refs.qForm.classList.remove('submitting');
				});
		},
	},
	template: `
<div class="booking-item-form-cancel">
	<a class="action-link" @click="$refs.qModalEditDialog.show()">{{$t('bookingItemCancelForm.cancelLink')}}</a>
	<qit-modal-dialog ref="qModalEditDialog" class="size-sm" @hide="onHideModalDialog">
    <form ref="qForm" class="client-form no-max-width" @submit.prevent="$refs.qConfirmDialog.show()">
      <div v-if="formTitle" class="form-top">{{formTitle}}</div>
      <template v-if="successMsg">
        <div class="form-msg success">
          <i class="qicon-1">check_outline_mini</i>
          <span v-t="successMsg"></span>
        </div>
        <div class="form-bottom">
          <span class="btn small text-transform-none button fill" @click="onHideModalDialog">OK</span>
        </div>
      </template>
			<template v-else>
        <slot name="cp-text"></slot>
        <div class="form-content">
          <qit-input-text
              name="bi[reason_text]" class="v1"
              :label="$t('bookingCancelForm.reasonText')"
              :floating-label="true"
              v-model="formData.reason_text"
              :error-msg="formErrors.reason_text"
          ></qit-input-text>
        </div>
        <div class="form-bottom">
          <button class="btn text-transform-none button fill" name="btnSubmit" :value="actionName" v-t="'bookingItemCancelForm.btnCancel'"></button>
        </div>
        <div v-if="formErrors.main" class="form-msg errors" v-t="formErrors.main"></div>
      </template>
      <div class="form-submitting-overlay"><div class="spin-loader"></div></div>
    </form>
    <qit-modal-dialog ref="qConfirmDialog" class="size-xs type-warning" :btn-ok="'OK'" :btn-cancel="$t('close')" @ok="onFormSubmit">{{$t('areYouSure')}}</qit-modal-dialog>
  </qit-modal-dialog>
</div>
`,
}